export default "__VITE_ASSET__BFAAHon$__"